// Radiant Bliss Aura - Clean, Vegan, Plant-Powered Skincare

// ============================================
// SITE IMAGES - Acure CDN
// ============================================
export const siteImages = {
  heroMain: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningCleansingGel_01.jpg?v=1762457557',
  heroSecondary: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Super-drench-feature.jpg?v=1776281682',
  heroLifestyle: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/advanced-barrier-09.jpg?v=1776735132',
  ctaBackground: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/future-fusion-09.jpg?v=1776734478',
  featuredBackground: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningDayCream_01.jpg?v=1762457339',
  powerBackground: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Glowserumbottlesquare.jpg?v=1762457335',
  shopBanner: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningCleansingGel_01.jpg?v=1762457557',
  aboutBanner: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/advanced-barrier-09.jpg?v=1776735132',
  contactBanner: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningDayCream_01.jpg?v=1762457339',
  returnsBanner: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/RRwhippednightcreamtubesquare.jpg?v=1762457354',
  privacyBanner: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/soothingdaycreantube.jpg?v=1762457728',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '3-5 business days';
export const FREE_SHIPPING_THRESHOLD = 75;

export const CARD_DESCRIPTOR = 'RADIANT BLISS AURA';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(833) 892-5039',
  email: 'contactus@radiantblissaura.com',
  corpName: 'Radan Capital Management LLC',
  domain: 'radiantblissaura.com',
  address: {
    street: '547 E Altgeld Ave',
    city: 'Glendale Heights',
    state: 'IL',
    zip: '60139',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// PRODUCTS — Acure-style skincare
// Prices restricted to the approved set only
// ============================================
export const products = [
  // ---------- CLEANSERS ----------
  {
    id: 'brightening-cleansing-gel',
    name: 'Brightening Cleansing Gel',
    slug: 'brightening-cleansing-gel',
    sku: 'RBA-BCG-001',
    price: 17.49,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningCleansingGel_01.jpg?v=1762457557',
    badge: 'Bestseller',
    categoryId: 'cleansers',
    categorySlug: 'cleansers',
    description: 'A daily brightening gel cleanser with sea kelp, blackberry and lemon to gently lift dirt and makeup while restoring a natural glow.',
    keyBenefits: ['Brightens dull, uneven skin tone', 'Gentle daily cleanse for all skin types', 'Vegan, cruelty-free, paraben-free'],
    usage: 'Apply a small amount to damp skin, massage gently in circular motions, then rinse with lukewarm water. Use morning and evening.',
    features: ['100% Vegan', 'Cruelty-Free', 'Sulfate-Free', 'Paraben-Free'],
    inStock: true,
  },
  {
    id: 'ultra-hydrating-green-juice-cleanser',
    name: 'Ultra Hydrating Green Juice Cleanser',
    slug: 'ultra-hydrating-green-juice-cleanser',
    sku: 'RBA-UGC-002',
    price: 17.49,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/UHcleanserSquare.jpg?v=1762457358',
    categoryId: 'cleansers',
    categorySlug: 'cleansers',
    description: 'A creamy, milk-like cleanser packed with cucumber, kale and aloe to deeply hydrate while lifting away impurities.',
    keyBenefits: ['Locks in skin-quenching hydration', 'Gentle, non-stripping cleanse', 'Made with plant-derived actives'],
    usage: 'Massage onto dry or damp skin, then rinse with warm water. Best used both morning and night.',
    features: ['For Dry Skin', 'Hydrating', 'Plant-Powered', 'Cruelty-Free'],
    inStock: true,
  },
  {
    id: 'resurfacing-glycolic-cleanser',
    name: 'Resurfacing Glycolic Acid Cleanser',
    slug: 'resurfacing-glycolic-cleanser',
    sku: 'RBA-RGC-003',
    price: 17.49,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/resurfacingGlycoliccleanserSquarecopy.jpg?v=1762457362',
    badge: 'Clarifying',
    categoryId: 'cleansers',
    categorySlug: 'cleansers',
    description: 'A daily exfoliating gel cleanser with 1% glycolic acid and unicorn root that smooths texture and refines pores without stripping.',
    keyBenefits: ['Smooths bumpy texture', 'Refines pores', 'Reveals a clearer, brighter glow'],
    usage: 'Lather a dime-sized amount with water, massage into skin, focus on T-zone, then rinse thoroughly. Use 2-3 times weekly to start.',
    features: ['1% Glycolic Acid', 'Vegan', 'For Oily Skin', 'Cruelty-Free'],
    inStock: true,
  },

  // ---------- SERUMS & TREATMENTS ----------
  {
    id: 'super-drench-serum',
    name: 'The Super Drench Serum',
    slug: 'super-drench-serum',
    sku: 'RBA-SDS-004',
    price: 34.98,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Super-drench-feature.jpg?v=1776281682',
    badge: 'Bestseller',
    categoryId: 'serums',
    categorySlug: 'serums',
    description: 'A weightless multi-molecular hyaluronic serum that delivers an instant flood of hydration for visibly plumper, dewier skin.',
    keyBenefits: ['Instant plumping hydration', 'Smooths fine lines from dryness', 'Lightweight, fast-absorbing'],
    usage: 'Apply 2-3 drops to clean, slightly damp skin morning and night. Follow with moisturizer to lock in hydration.',
    features: ['Hyaluronic Acid', 'Vegan', 'Fragrance-Free', 'Lightweight'],
    inStock: true,
  },
  {
    id: 'brightening-vitamin-c-serum',
    name: 'Brightening 2% Vitamin C & Ferulic Acid Serum',
    slug: 'brightening-vitamin-c-serum',
    sku: 'RBA-BVC-005',
    price: 52.47,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/https_acure.com_collections_serums_products_brightening-vitamin-c-ferulic-acid-serum.jpg?v=1762457349',
    badge: 'Premium',
    categoryId: 'serums',
    categorySlug: 'serums',
    description: 'A daily antioxidant serum pairing stabilized vitamin C with ferulic acid to even tone, fade dark spots and protect against environmental stress.',
    keyBenefits: ['Brightens uneven skin tone', 'Fades the look of dark spots', 'Antioxidant protection'],
    usage: 'Apply 3-4 drops to clean skin each morning. Follow with moisturizer and broad-spectrum SPF.',
    features: ['Vitamin C', 'Ferulic Acid', 'Vegan', 'Antioxidant'],
    inStock: true,
  },
  {
    id: 'ai-peptide-serum',
    name: 'AI Peptide Serum',
    slug: 'ai-peptide-serum',
    sku: 'RBA-APS-006',
    price: 52.47,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/AIPeptideMainimage.jpg?v=1762458282',
    badge: "Editor's Pick",
    categoryId: 'serums',
    categorySlug: 'serums',
    description: 'A next-generation peptide serum formulated to visibly firm, smooth and renew skin for a youthful, lit-from-within finish.',
    keyBenefits: ['Visibly firms and smooths', 'Supports skin renewal', 'Lightweight, layerable texture'],
    usage: 'Apply a few drops to clean skin morning and night, before moisturizer.',
    features: ['Peptides', 'Vegan', 'Anti-Aging', 'Cruelty-Free'],
    inStock: true,
  },
  {
    id: 'brightening-glow-serum',
    name: 'Brightening Glow Serum',
    slug: 'brightening-glow-serum',
    sku: 'RBA-BGS-007',
    price: 34.98,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Glowserumbottlesquare.jpg?v=1762457335',
    categoryId: 'serums',
    categorySlug: 'serums',
    description: 'A daily glow serum with Gotu Kola, blackberry and rosehip oil to revive dull skin and deliver an immediate radiant finish.',
    keyBenefits: ['Reveals an immediate glow', 'Boosts radiance over time', 'Smooths and hydrates'],
    usage: 'Apply 2-3 drops to clean skin morning and night. Pairs well with vitamin C serum.',
    features: ['Gotu Kola', 'Rosehip', 'Vegan', 'For All Skin Types'],
    inStock: true,
  },

  // ---------- MOISTURIZERS ----------
  {
    id: 'radically-rejuvenating-night-cream',
    name: 'Radically Rejuvenating Whipped Night Cream',
    slug: 'radically-rejuvenating-night-cream',
    sku: 'RBA-NCR-008',
    price: 35.96,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/RRwhippednightcreamtubesquare.jpg?v=1762457354',
    badge: 'Bestseller',
    categoryId: 'moisturizers',
    categorySlug: 'moisturizers',
    description: 'A whipped, mousse-like night cream rich in rosehip oil and chlorella that deeply nourishes skin while you sleep.',
    keyBenefits: ['Deeply nourishes overnight', 'Restores moisture barrier', 'Wakes skin up plump and refreshed'],
    usage: 'Smooth a generous layer over face and neck as the last step of your nighttime routine.',
    features: ['Rosehip Oil', 'Vegan', 'Rich Texture', 'Cruelty-Free'],
    inStock: true,
  },
  {
    id: 'brightening-day-cream',
    name: 'Brightening Day Cream',
    slug: 'brightening-day-cream',
    sku: 'RBA-BDC-009',
    price: 26.97,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningDayCream_01.jpg?v=1762457339',
    categoryId: 'moisturizers',
    categorySlug: 'moisturizers',
    description: 'A lightweight daily moisturizer with Gotu Kola and antioxidants for an instantly radiant, even-looking complexion.',
    keyBenefits: ['Brightens uneven skin tone', 'Hydrates without heaviness', 'Sits beautifully under makeup'],
    usage: 'Apply to cleansed face and neck every morning. Always follow with broad-spectrum SPF.',
    features: ['Vitamin C', 'Gotu Kola', 'Vegan', 'Daily Use'],
    inStock: true,
  },
  {
    id: 'soothing-day-cream',
    name: 'Seriously Soothing Day Cream',
    slug: 'soothing-day-cream',
    sku: 'RBA-SSD-010',
    price: 26.97,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/soothingdaycreantube.jpg?v=1762457728',
    categoryId: 'moisturizers',
    categorySlug: 'moisturizers',
    description: 'A calming daily moisturizer with peony, aloe and argan oil designed for reactive and sensitive skin.',
    keyBenefits: ['Calms redness on contact', 'Reinforces skin barrier', 'Fragrance-free formula'],
    usage: 'Smooth a small amount over face and neck each morning, after cleansing and serum.',
    features: ['For Sensitive Skin', 'Fragrance-Free', 'Vegan', 'Argan Oil'],
    inStock: true,
  },
  {
    id: 'advanced-barrier-moisturizer',
    name: 'Advanced Barrier Support Moisturizer',
    slug: 'advanced-barrier-moisturizer',
    sku: 'RBA-ABS-011',
    price: 35.96,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/advanced-barrier-09.jpg?v=1776735132',
    badge: 'New',
    categoryId: 'moisturizers',
    categorySlug: 'moisturizers',
    description: 'A barrier-restoring moisturizer with ceramides, niacinamide and squalane to strengthen, hydrate and visibly calm stressed skin.',
    keyBenefits: ['Strengthens the moisture barrier', '24-hour comfort and hydration', 'Calms reactivity and redness'],
    usage: 'Apply to clean skin morning and night. Can be layered over serum.',
    features: ['Ceramides', 'Niacinamide', 'Squalane', 'Vegan'],
    inStock: true,
  },

  // ---------- MASKS & EXFOLIATORS ----------
  {
    id: 'brightening-facial-scrub',
    name: 'Brightening Facial Scrub',
    slug: 'brightening-facial-scrub',
    sku: 'RBA-BFS-012',
    price: 8.99,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningFacialScrub_01.jpg?v=1762457340',
    badge: 'Mini',
    categoryId: 'masks',
    categorySlug: 'masks',
    description: 'A creamy exfoliating scrub with sea kelp and French green clay that polishes away dullness for instantly radiant skin.',
    keyBenefits: ['Polishes and refines texture', 'Reveals brighter skin', 'Gentle enough for weekly use'],
    usage: 'Apply to damp skin, massage in circular motions for 1 minute, then rinse with warm water. Use 2-3 times weekly.',
    features: ['Sea Kelp', 'Vegan', 'Travel Size', 'Cruelty-Free'],
    inStock: true,
  },
  {
    id: 'zombie-clarifying-mask',
    name: 'Zombie Cell Clarifying Mask',
    slug: 'zombie-clarifying-mask',
    sku: 'RBA-ZCM-013',
    price: 11.49,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/ZombieMaskJar.jpg?v=1762458188',
    badge: 'Mini',
    categoryId: 'masks',
    categorySlug: 'masks',
    description: 'A purifying clay mask powered by activated charcoal and tomato stem cells to detox pores and refresh tired skin.',
    keyBenefits: ['Detoxifies and clarifies pores', 'Boosts visible radiance', 'Cooling, non-stripping clay blend'],
    usage: 'Apply a thin, even layer to clean skin. Leave on for 10 minutes, then rinse with warm water. Use weekly.',
    features: ['Activated Charcoal', 'Tomato Stem Cells', 'Vegan', 'Weekly Treat'],
    inStock: true,
  },
  {
    id: 'resilience-eye-balm',
    name: 'Resilience Eye Balm',
    slug: 'resilience-eye-balm',
    sku: 'RBA-REB-014',
    price: 17.98,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_EyeBalm_01.jpg?v=1762457829',
    categoryId: 'masks',
    categorySlug: 'masks',
    description: 'A nourishing eye balm with peptides and plant butters that visibly smooths fine lines and brightens the under-eye area.',
    keyBenefits: ['Smooths the look of fine lines', 'Brightens dark circles', 'Long-lasting comfort'],
    usage: 'Warm a small amount on fingertips and gently pat around the eye area morning and night.',
    features: ['Peptides', 'Plant Butters', 'Vegan', 'Eye Area'],
    inStock: true,
  },

  // ---------- BODY CARE ----------
  {
    id: 'argan-oil',
    name: 'Argan Oil (Multi-Use)',
    slug: 'argan-oil',
    sku: 'RBA-AO-015',
    price: 26.97,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Arganoilbottlesquare_6fe4e582-6171-428c-8553-95efd888a97b.jpg?v=1762457360',
    categoryId: 'body',
    categorySlug: 'body',
    description: 'A 100% pure cold-pressed argan oil for face, body and hair — rich in vitamin E and essential fatty acids for deep nourishment.',
    keyBenefits: ['Multi-use: face, body and hair', 'Deeply nourishes and softens', 'Fast-absorbing, non-greasy'],
    usage: 'Massage a few drops into damp skin or hair. Use as the last step of your routine.',
    features: ['100% Argan Oil', 'Cold-Pressed', 'Vegan', 'Multi-Use'],
    inStock: true,
  },
  {
    id: 'invisible-sunscreen-stick',
    name: 'Invisible Sunscreen Stick SPF 50',
    slug: 'invisible-sunscreen-stick',
    sku: 'RBA-SUN-016',
    price: 26.97,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/sunscreen_stick_image_1.jpg?v=1762457855',
    badge: 'SPF',
    categoryId: 'body',
    categorySlug: 'body',
    description: 'A weightless mineral SPF 50 sunscreen stick that glides on invisibly — perfect for daily reapplication on face and body.',
    keyBenefits: ['Broad-spectrum SPF 50 protection', 'Invisible, non-greasy finish', 'Reef-friendly mineral filters'],
    usage: 'Glide over clean skin 15 minutes before sun exposure. Reapply every 2 hours.',
    features: ['SPF 50', 'Mineral', 'Reef-Friendly', 'Vegan'],
    inStock: true,
  },

  // ---------- BUNDLES / GIFT SETS ----------
  {
    id: 'everyday-skincare-basics',
    name: 'Everyday Skincare Basics Gift Set',
    slug: 'everyday-skincare-basics',
    sku: 'RBA-SET-017',
    price: 120.08,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Everyday_Skincare_Basics_Set.jpg?v=1764787760',
    badge: 'Bundle',
    categoryId: 'sets',
    categorySlug: 'sets',
    description: 'A curated 4-piece bundle of everyday essentials — cleanser, serum, day cream and exfoliating scrub for your glow ritual.',
    keyBenefits: ['Complete daily glow routine', 'Saves vs. buying separately', 'Travel-friendly sizes'],
    usage: 'Use morning: cleanse, serum, day cream. Evening: cleanse, scrub (2-3x weekly).',
    features: ['4-Piece Set', 'Best Value', 'Vegan', 'Gift Ready'],
    inStock: true,
  },
  {
    id: 'brightening-essentials-set',
    name: 'Brightening Essentials Skincare Set',
    slug: 'brightening-essentials-set',
    sku: 'RBA-SET-018',
    price: 213.32,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Brightening_Essentials-Skincare-Set.jpg?v=1764785926',
    badge: 'Bundle',
    categoryId: 'sets',
    categorySlug: 'sets',
    description: 'A complete brightening ritual — cleanser, vitamin C serum, glow serum, day cream and night cream — for visibly radiant skin.',
    keyBenefits: ['Day-and-night brightening ritual', 'Full-size formulas', 'Visible glow in weeks'],
    usage: 'AM: cleanse → vitamin C serum → day cream → SPF. PM: cleanse → glow serum → night cream.',
    features: ['5-Piece Set', 'Full Routine', 'Vegan', 'Gift Ready'],
    inStock: true,
  },
  {
    id: 'head-to-toe-radiance-set',
    name: 'Head-to-Toe Radiance Gift Set',
    slug: 'head-to-toe-radiance-set',
    sku: 'RBA-SET-019',
    price: 239.94,
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/age-defying-bundle-GIFT_3.jpg?v=1764799237',
    badge: 'Limited',
    categoryId: 'sets',
    categorySlug: 'sets',
    description: 'Our most luxurious head-to-toe collection — face cleanse, serums, moisturizers, eye care and body essentials in beautiful gift packaging.',
    keyBenefits: ['Every face and body essential', 'Exclusive savings', 'Beautiful gift packaging'],
    usage: 'Build a personalized day-and-night routine. Includes a guide for layering and timing.',
    features: ['8-Piece Set', 'Luxury Gift', 'Vegan', 'Limited Edition'],
    inStock: true,
  },
];

// ============================================
// CATEGORIES — Acure-style with real imagery
// ============================================
export const categories = [
  {
    id: 'cleansers',
    name: 'Cleansers',
    slug: 'cleansers',
    description: 'Daily cleansers to gently lift away impurities and prep skin to glow',
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningCleansingGel_01.jpg?v=1762457557',
    productCount: 3,
  },
  {
    id: 'serums',
    name: 'Serums & Treatments',
    slug: 'serums',
    description: 'Targeted, concentrated formulas for hydration, brightness and renewal',
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Super-drench-feature.jpg?v=1776281682',
    productCount: 4,
  },
  {
    id: 'moisturizers',
    name: 'Moisturizers',
    slug: 'moisturizers',
    description: 'Day and night creams to nourish, plump and protect your barrier',
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/RRwhippednightcreamtubesquare.jpg?v=1762457354',
    productCount: 4,
  },
  {
    id: 'masks',
    name: 'Masks & Exfoliators',
    slug: 'masks',
    description: 'Weekly polish, mask and eye treatments for visibly radiant skin',
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/PDP_BrighteningFacialScrub_01.jpg?v=1762457340',
    productCount: 3,
  },
  {
    id: 'body',
    name: 'Body & SPF',
    slug: 'body',
    description: 'Plant-powered body essentials and daily sun protection',
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/sunscreen_stick_image_1.jpg?v=1762457855',
    productCount: 2,
  },
  {
    id: 'sets',
    name: 'Gift Sets',
    slug: 'sets',
    description: 'Curated rituals and luxury collections — a gift of radiant skin',
    image: 'https://cdn.shopify.com/s/files/1/0550/4896/2261/files/Brightening_Essentials-Skincare-Set.jpg?v=1764785926',
    productCount: 3,
  },
];

// ============================================
// FEATURES / BENEFITS / STEPS
// ============================================
export const features = [
  { id: 1, title: 'Plant-Powered', description: 'Formulas built around clean, plant-derived actives that actually work' },
  { id: 2, title: 'Free USA Shipping', description: 'Free shipping on every order over $75 within the USA' },
  { id: 3, title: '30-Day Returns', description: 'Love it or return it — easy, no-questions-asked refunds' },
  { id: 4, title: 'Vegan & Cruelty-Free', description: '100% vegan and never tested on animals' },
];

export const performanceBenefits = [
  { id: 1, title: 'Radiance', description: 'Visibly brighter, more even-looking skin with daily care' },
  { id: 2, title: 'Hydration', description: 'Lightweight formulas that deeply quench and plump' },
  { id: 3, title: 'Clarity', description: 'Refined pores, smoother texture and a clear, healthy glow' },
  { id: 4, title: 'Calm', description: 'Soothing actives that comfort sensitive, reactive skin' },
];

export const steps = [
  { id: 1, title: 'Discover Your Ritual', description: 'Explore plant-powered skincare designed for every skin type.' },
  { id: 2, title: 'Build Your Routine', description: 'Pick a cleanser, serum and moisturizer that suit your skin goals.' },
  { id: 3, title: 'Secure Checkout', description: 'Safe, encrypted checkout with payment data fully protected.' },
  { id: 4, title: 'Glow Daily', description: 'Open the box, layer on your ritual, and let your aura shine.' },
];
